import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { getButtonAttributes } from '../../helpers/button.js';
import { EButtonSize, EButtonVariant } from './CgButton.types.js';
import { CgReactRouterLinkAsButton as CgReactRouterLinkAsButton$1 } from './CgButton.styles.js';

var CgReactRouterLinkAsButton = function CgReactRouterLinkAsButton(_a) {
  var children = _a.children,
      _b = _a.size,
      size = _b === void 0 ? EButtonSize.medium : _b,
      _c = _a.variant,
      variant = _c === void 0 ? EButtonVariant.primary : _c,
      props = __rest(_a, ["children", "size", "variant"]);

  var _d = getButtonAttributes(size, variant),
      sizeAttributes = _d.sizeAttributes,
      variantAttributes = _d.variantAttributes;

  return React.createElement(CgReactRouterLinkAsButton$1, __assign({
    backgroundColor: variantAttributes.backgroundColor,
    backgroundHover: variantAttributes.backgroundHover,
    backgroundDisabled: variantAttributes.backgroundDisabled,
    backgroundActive: variantAttributes.backgroundActive,
    border: variantAttributes.border,
    boxShadow: props.boxShadow,
    circle: props.circle,
    fontColor: variantAttributes.fontColor,
    fontSize: sizeAttributes.fontSize,
    height: sizeAttributes.height,
    fullWidth: props.fullWidth,
    paddingX: sizeAttributes.paddingX,
    paddingY: sizeAttributes.paddingY,
    rounded: props.rounded,
    size: size
  }, props), children);
};

export { CgReactRouterLinkAsButton };